import React from 'react';
import { CalendarProvider } from '../context/CalendarContext';
import { CalendarNavigationProvider } from '../context/CalendarNavigationContext';
import { CalendarSelectionProvider } from '../context/CalendarSelectionContext';

const CalendarRoot = ({
  children,
  trainerId,
  schoolId,
  workingHours = [],
  basePath = '/calendar',
  features = {},
  multiSelect = false,
  maxSelections = 20,
  onEventClick,
  onSlotClick,
  onEventChange,
  onSelectionChange,
  className = '',
}) => {
  return (
    <CalendarNavigationProvider basePath={basePath}>
      <CalendarProvider
        trainerId={trainerId}
        schoolId={schoolId}
        workingHours={workingHours}
        features={features}
        onEventClick={onEventClick}
        onSlotClick={onSlotClick}
        onEventChange={onEventChange}
      >
        <CalendarSelectionProvider
          multiSelect={multiSelect}
          maxSelections={maxSelections}
          onSelectionChange={onSelectionChange}
        >
          <div className={`calendar-root ${className}`}>
            {children}
          </div>
        </CalendarSelectionProvider>
      </CalendarProvider>
    </CalendarNavigationProvider>
  );
};

export default CalendarRoot;
